<template>
  <span
    class="basic-button"
    :class="{'disabled': btnDisabled, 'has-shadow': hasShadow}"
    @click.stop="onBodyClick"
  ><span class="text-wrap" :style="{'background': paramBackground,}"><slot></slot></span></span>
</template>

<script>
export default {
  name: 'BasicButton',
  props: {
    hasShadow: {
      type: Boolean,
      default: false,
    },
    bgString: {
      type: String,
      default: 'linear-gradient(90deg, #de3636 6.67%, #f86262 92.29%)'
    },
    btnDisabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    paramBackground() {
      return this.btnDisabled ? 'white' : this.bgString
    },
  },
  methods: {
    onBodyClick() {
      this.$emit('btn-click')
    }
  }
}</script>

<style scoped lang="scss">
.basic-button {
  width: 100%;
  display: inline-block;
  position: relative;
  cursor: pointer;
  color: white;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  .text-wrap {
    width: 100%;
    height: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-height: 55px;
    border-radius: 9999px;
    position: relative;
    z-index: 10;
    padding: 14px 38px;
  }
  &.has-shadow {
    &::after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 4px;
      left: 0;
      border-radius: 9999px;
      background: rgba(1, 3, 15, 0.8);
    }
  }
  &.disabled {
    $col_disable: #dcdfe2;
    .text-wrap {
      border: 2px solid $col_disable;
      background: white;
      color: $col_disable;
      pointer-events: none;
      cursor: default;
    }
    &.has-shadow {
      &::after {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2023/partials/BasicButton.vue